import { Container } from 'inversify-props';
import TYPES from './types';

// Infrastructure
import GoalEarningsHttpRepository from './infrastructure/repositories/goal-earnings-http-repository';

// Application
import GetGoalEarningsQuery from './application/queries/get-goal-earnings-query';

// Domain
import { GoalEarningsRepository } from './domain/repositories/goal-earnings-repository';

export default function setupGoalTracking(container: Container) {
  container
    .bind<GoalEarningsRepository>(
      TYPES.GOAL_EARNINGS_REPOSITORY,
    ).to(GoalEarningsHttpRepository).inSingletonScope();

  container
    .bind<GetGoalEarningsQuery>(
      TYPES.GET_GOAL_EARNINGS_QUERY,
    ).to(GetGoalEarningsQuery)
    .inSingletonScope();
}
